import React, { Component } from 'react';
import classnames from 'classnames';
import { getSysFieldid } from '@platform/api';

export default function connect(Table) {
    return class TableWithStore extends Component {
        constructor (props) {
            super(props);
            let { store } = props;
            // 为了让store获取props
            store.getInstance().register('Table', this);
            this.uuid = store.getInstance().uuid;
            window[this.uuid] = store.getInstance();
        }

        render() {
            let { flex, fieldid, id } = this.props,
                propsGenerator = this.props.store.getInstance().getPropsGenerator();

            return <div 
                uuid={this.uuid} 
                className={classnames('table-next-wrapper', { "flex-container": flex })}
                fieldid={getSysFieldid(`${fieldid || id}_table`)}
            >
                <Table 
                    {...propsGenerator.reduce((props, HOC) => {
                        let nextProps = HOC(props);
                        if (nextProps) {
                            return nextProps;
                        } else {
                            console.warn('propsGenerator需要返回新的props，当前propsGenerator为', HOC);
                            return props;
                        }
                    }, this.props)} 
                />
            </div>;
        }

        componentWillUnmount() {
            this.props.store.getInstance().unregister('Table', this);
            delete window[this.uuid];
        }
    };
}

connect.displayName = 'connect';
connect.dependence = [];